import { SnapOperationCostParams } from '@calculations/cost';

import { QuoteBuilderWorkOrderType } from '../../types/state/work-order';

export function storeToCalculationOperations(
  snapWorkOrder: QuoteBuilderWorkOrderType,
): SnapOperationCostParams[] {
  return Object.values(snapWorkOrder.snapOperations).map(
    ({ snapRequirements, ...operation }) => ({
      ...operation,
      snapRequirements: Object.values(snapRequirements),
    }),
  );
}
